import React, { useEffect } from 'react';
import { useAppDispatch } from '../app/hooks';
import Body from '../components/Body';
import TaskRouterOnBanner from '../components/TaskRouterOnBanner';
import { setNavigationViaTaskRouter } from '../redux/features/taskRouter/taskRouter.slice';

const LandingPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setNavigationViaTaskRouter(false));
  }, []);

  return (
    <div data-testid="landing-page">
      {/* Direct-HITL route only — the task-router assignment path renders
          RestaurantPage, so this advisory can never reach a routed agent. */}
      <TaskRouterOnBanner />
      <Body />
    </div>
  );
};

export default LandingPage;
